var _excluded = ["errorCode"],
  _excluded2 = ["requestId"];
var _jsxFileName = "/repo/packages/webassets/src/components/ClientError/ClientErrorPage.tsx",
  _this = this;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { LogoWithText } from '../Logos';
import { withWebAssetsTheme } from '../../theme';
import useStyles from './useErrorPageStyles';
export var HttpErrorPage = function HttpErrorPage(_ref) {
  var children = _ref.children,
    errorCode = _ref.errorCode,
    requestId = _ref.requestId;
  var _useStyles = useStyles(),
    pageContainer = _useStyles.pageContainer,
    childrenContainer = _useStyles.childrenContainer,
    pageLogoLink = _useStyles.pageLogoLink,
    hashMessageId = _useStyles.hashMessageId;
  var logoLinkId = 'HttpErrorPage_Logo_Link';
  var hashMessage = requestId ? "".concat(errorCode, ": ").concat(requestId) : '';
  var hashMessageTestId = 'HttpErrorPage_Hash_Message';
  return /*#__PURE__*/React.createElement("div", {
    className: pageContainer,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    "data-testid": logoLinkId,
    className: pageLogoLink,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(LogoWithText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: childrenContainer,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement("div", {
    "data-testid": hashMessageTestId,
    className: hashMessageId,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 7
    }
  }, hashMessage));
};
export var withHttpErrorPage = function withHttpErrorPage(Component, _ref2) {
  var errorCode = _ref2.errorCode,
    defaultComponentProps = _objectWithoutProperties(_ref2, _excluded);
  return function (_ref3) {
    var requestId = _ref3.requestId,
      props = _objectWithoutProperties(_ref3, _excluded2);
    var componentProps = _objectSpread(_objectSpread({}, defaultComponentProps), props);
    return /*#__PURE__*/React.createElement(HttpErrorPage, {
      errorCode: errorCode,
      requestId: requestId,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Component, Object.assign({}, componentProps, {
      fullscreen: false,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 9
      }
    })));
  };
};
export default withWebAssetsTheme(HttpErrorPage);
//# sourceMappingURL=ClientErrorPage.js.map